import { ButtonHTMLAttributes, FC } from 'react';
import styles from './IconButton.module.scss';
import { ButtonVariant } from '../../Button/model/types/ButtonVariant';
import Button from '../../Button/ui/Button';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  disabled?: boolean;
  url?: string;
  isLoading?: boolean;
}

/**
 * General and reusable component. It's clickable. Should be used for buttons with images
 * @param children - The content to be displayed inside the button.
 * @param className - string
 * @param variant - "active" | "danger" | "underline" | "text" | "menu" | "inverted".
 * @param disabled - true | false\
 * @param url - string - Make the button trough a tag and acts as a download button
 * @param isLoading - true | false
 * @returns A button element representing the button.
 */
const IconButton: FC<IconButtonProps> = (props) => {
  const {
    children,
    className,
    disabled = false,
    variant,
    isLoading = false,
    ...restProps
  } = props;

  const handleClick = () => {};

  return (
    <Button
      className={[
        styles.iconButton,
        className,
        disabled && styles.disabled,
      ].join(' ')}
      variant={variant}
      disabled={disabled}
      isLoading={isLoading}
      onClick={handleClick}
      {...restProps}
    >
      {children}
    </Button>
  );
};

export default IconButton;
